import React, {useEffect, useState} from 'react'
import {Grid} from "semantic-ui-react";
import Pronunciation from "./Pronunciation";
import _ from "lodash";
import PronunciationCard from "./PronunciationCard";
import '../../style.css'
import firebase from "firebase";
import axios from "axios";
import {UserVisitedPage} from "../../helpers/UserVisitedPage";
import {SaveRecordingData} from "../../helpers/SaveRecordingData";
import {CreateRecordingAssignmentOptions} from "../../helpers/CreateRecordingAssignmentOptions";

function PronunciationWrapper(
    {
        classLevel
    }
) {

    //[Quizzing variables]
    //Random number is used to select a random button to highlight
    const [randNum, setRandNum] = useState(null);
    //This timer is used in timeout to generate a new random number
    const [timer, setTimer] = useState(4000);
    //isClicked refers to starting the quiz
    const [isClicked, setIsClicked] = useState(false);
    //holds the ID of of timeout to start quiz
    const [start, setStart] = useState(0);
    const [buttons, setButtons] = useState(null);
    //speakTimer is used for the timeout for the computer to pronounce the correct pronunciation when quizzing
    const [speakTimer, setSpeakTimer] = useState(3500);
    const [changeColorTime, setChangeColorTime] = useState(null);

    //[Recording Student data]
    const [open, setOpen] = useState(false);
    const [record, setRecord] = useState(false);
    const [blobURL, setBlobURL] = useState('');
    const [blob, setBlob] = useState(new Blob);
    const [toggleRecording, setToggleRecording] = useState(false);

    //[Assignment data]
    const [assignmentNum, setAssignmentNum] = useState(null);
    const [assignment, setAssignment] = useState([]);
    const [assignmentOptions, setAssignmentOptions] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [sound, setSound] = useState([]);

    //[Loading & User Messages]
    const [loading, setLoading] = useState(true);
    const [assignmentChosen, setAssignmentChosen] = useState(false)
    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');
    const [success, setSuccess] = useState(false);


    useEffect(() => {
        //asynchronous function to fetch assignments and create file names for options
        async function fetchData() {
            let retrievedFileNames = [];

            //Fetching the names of the assignments => (assignment1.json, assignment2.json etc..)
            await firebase.storage().ref().child('assignments/Samoan101/pronunciationAssignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        retrievedFileNames.push(folderRef.location.path_.split('/')[3])
                    })
                }).catch(e => console.log(e));
            let tmpAssignments = [];

            //Fetches the assignments by name.
            //IT IS DONE THIS WAS SO ASSIGNMENTS ARE RETRIEVED IN ORDER
            //If not, assignments will be labeled (Assignment 1, "Assignment 10") which is wrong
            for (let i = 1; i <= retrievedFileNames.length; i++) {
                const assignments = firebase.storage().ref().child(`assignments/Samoan101/pronunciationAssignments/assignment${i}.json`);
                await assignments.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => tmpAssignments.push(res.data));
                setProgress(prevState => prevState + Math.round(100 / retrievedFileNames.length));
                setProgressText('Loading assignments')
            }
            setAssignments(tmpAssignments);

            //Creating the options for the dropdown
            CreateRecordingAssignmentOptions(tmpAssignments, 1, 'pronunciationData')
                .then((res)=>{
                    setAssignmentOptions(res)

                })

        }

        fetchData().then(r => setLoading(false)).catch(e => console.log(e));

        //Function call to update student views
        UserVisitedPage();

    }, []);

    //Timeout called to erase success message after finishing recording
    useEffect(()=>{
        setTimeout(()=>{
            setSuccess(false)
        }, 5000)
    },[success])

    //[Functions to start/stop Recording]
    const startRecording = () => {
        setRecord(true);
        setBlobURL('')
        setBlob(new Blob)
    };
    const stopRecording = () => {
        setRecord(false);
    };
    const onStop = (recordedBlob) => {
        setBlobURL(recordedBlob.blobURL);
        setBlob(recordedBlob)
    };

    //Sets new button to highlight
    useEffect(() => {
        setButtons(_.times(assignment.length, (i) => (
            <Grid.Column key={i} width={2}>
                {randNum === i ?
                    <PronunciationCard name={assignment[i].name} file={sound[i]}
                                       pronunciationButtonStyle='pronunciationButtonStyleClicked'/>
                    :
                    <PronunciationCard name={assignment[i].name} file={sound[i]}
                                       pronunciationButtonStyle='pronunciationButtonStyle'/>
                }
            </Grid.Column>)
        ));
    }, [changeColorTime]);

    //isClicked refers to start quiz
    useEffect(() => {
        if (isClicked) {
            clearInterval(start);
            clearTimeout(speakTimer);
            setTimeout(() => {
                setChangeColorTime(randNum)

            }, 0);
            setStart(setInterval(() => {
                startQuiz();
                clearInterval(start);
                changeTimer()
            }, timer));
            setTimeout(() => {
                sound[randNum].play()
            }, speakTimer);
        }
    }, [randNum]);

    //Starting quiz: time decrements over time at 100 ms
    const changeTimer = () => {
        //minimum for difficulty
        if (timer >= 2100) {
            setTimer(prevState => prevState - 100);
            //speak timer is set to 500 ms seconds after the button is highlighted
            setSpeakTimer(timer - 500)
        }

    };
    const startQuiz = () => {
        setIsClicked(true);

        //Generates random number
        const min = 0;
        const max = assignment.length;
        const rand = min + Math.random() * (max - min);
        setRandNum(Math.floor(rand));

        if (toggleRecording) {
            startRecording()
        }
    };

    const stopQuiz = () => {
        setIsClicked(false);
        setOpen(false);
        clearTimeout(speakTimer);
        clearInterval(start);
        stopRecording();
        setRandNum(null);
        setButtons(_.times(assignment.length, (i) => (
            <Grid.Column key={i} width={2}>
                <PronunciationCard name={assignment[i].name} file={sound[i]}
                                   pronunciationButtonStyle='pronunciationButtonStyle'/>
            </Grid.Column>)));
    };

    //Handles difficulty level
    //speak timer for computer to speak is set to 500 ms after color is highlighted
    const handleSlider = (e) => {
        setTimer(e.target.value);
        setSpeakTimer(e.target.value - 500)
    };

    const handleAssignmentChange = (event, {value}) => {
        setProgress(0)
        setAssignmentNum(value);
        setAssignment(assignments[value]);
        setLoading(true)

        //fetches all sounds for the assignment
        async function fetchSounds() {
            setAssignmentChosen(false);
            let retrievedSoundsURLArray = [];
            let tmpSounds = [];

            //fetch all sounds in the assignment
            for (let i = 0; i < assignments[value].length; i++) {
                const retrievedSound = firebase.storage().ref().child('sounds/' + assignments[value][i].file);
                await retrievedSound.getDownloadURL().then((url) => {
                    retrievedSoundsURLArray.push(url);
                    tmpSounds.push(new Audio(url));
                    setProgress(prevState => prevState + Math.round(100 / assignments[value].length));
                    setProgressText('Loading sounds')
                })
            }
            setSound(tmpSounds)
            setButtons(_.times(assignments[value].length, (i) => (
                <Grid.Column key={i} width={2}>
                    <PronunciationCard name={assignments[value][i].name} file={tmpSounds[i]}
                                       pronunciationButtonStyle='pronunciationButtonStyle'/>
                </Grid.Column>)));
        }

        fetchSounds().then(r => {
                setLoading(false)
                setAssignmentChosen(true);
            }
        ).catch(e => console.log(e));

        //resets quiz in case user decides to switch assignment in the middle of quizzing
        stopQuiz()
    };

    const handleToggleRecording = () => {
        setToggleRecording(prevState => !prevState)
    };

    const handleSaveRecording = () => {
        //Function call to save recording to database
        SaveRecordingData(classLevel, 'pronunciationData', blob, assignmentNum).then((res)=>{
            setSuccess(res);
            //update dropdown to implement mic emoji
            CreateRecordingAssignmentOptions(assignments, 1, 'pronunciationData')
                .then((res)=>{
                    setAssignmentOptions(res)
                })
        })
    };

    return (
        <>
            <Pronunciation
                loading={loading}
                randNum={randNum}
                open={open}
                setOpen={setOpen}
                timer={timer}
                isClicked={isClicked}
                toggleRecording={toggleRecording}
                handleToggleRecording={handleToggleRecording}
                assignmentOptions={assignmentOptions}
                handleAssignmentChange={handleAssignmentChange}
                assignmentNum={assignmentNum}
                blobURL={blobURL}
                onStop={onStop}
                record={record}
                handleSlider={handleSlider}
                buttons={buttons}
                startQuiz={startQuiz}
                stopQuiz={stopQuiz}
                progress={progress}
                progressText={progressText}
                assignmentChosen={assignmentChosen}
                handleSaveRecording={handleSaveRecording}
                success={success}
            />
        </>
    )
}

export default PronunciationWrapper
